import { render, staticRenderFns } from "./DeviceInfoPerformaceTop.vue?vue&type=template&id=0ea64e22&"
import script from "./DeviceInfoPerformaceTop.vue?vue&type=script&lang=js&"
export * from "./DeviceInfoPerformaceTop.vue?vue&type=script&lang=js&"
import style0 from "./DeviceInfoPerformaceTop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports